module.exports = __webpack_public_path__ + "static/media/3DPPA35.a6c81d2d.jpg";